import type { QuickSearchCatalogPage } from "app/components/React/QuickSearch/pageData/getQuickSearchCatalogPages";

export const filterQuickSearchCatalogBySummary = (
    pages: QuickSearchCatalogPage[],
    query: string,
    maxResults: number,
): QuickSearchCatalogPage[] => {
    const q = query.trim().toLowerCase();
    if (!q) {
        return [];
    }

    const matchedPages = pages.filter((page) => page.summary.toLowerCase().includes(q));

    // Surface pages whose title contains the query first, keeping the original
    // relative order within each group (stable sort).
    const titleMatches = matchedPages.filter((page) => page.title.toLowerCase().includes(q));
    const otherMatches = matchedPages.filter((page) => !page.title.toLowerCase().includes(q));

    return [...titleMatches, ...otherMatches].slice(0, maxResults);
};
